import { render, staticRenderFns } from "./ModalQuestion.vue?vue&type=template&id=17013810&scoped=true&"
import script from "./ModalQuestion.vue?vue&type=script&lang=ts&"
export * from "./ModalQuestion.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17013810",
  null
  
)

export default component.exports